import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";

export const ProgressBar = () => {
  return (
    <>
      <LinearProgress />
    </>
  );
};
